<template>
    <div class="main-wrap">
        <header-ui></header-ui>
        <main class="content">
            <router-view/>
            <row-buttons></row-buttons>
            <div class="row-button">
                <a href="https://web.tua.ng/?refresh" target="_blank" class="button button-primary">create account</a>
            </div>
        </main>
        <footer-ui></footer-ui>
        <modal v-if="showModal" v-on:close="showModal = false"></modal>
    </div>
</template>

<script>
import header from './components/header';
import rowButtons from './components/rowButtons';
import footer from './components/footer';
import modal from './components/modal';

export default {
  data() {
    return {};
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.showModal;
      },
      set(value) {
        this.$store.commit('toggleModal', value);
      }
    }
  },
  components: {
    'header-ui': header,
    'row-buttons': rowButtons,
    'footer-ui': footer,
    modal
  }
};
</script>

<style>
.content {
  margin-bottom: 30px;
}
.content .nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}
.content .nav-menu li {
  display: inline-block;
}
.content .nav-menu li a {
  color: #000;
}
.content h1 {
  font-family: 'SF Display Bold';
  color: #656565;
}
.content p {
}
.content ul {
  margin: 0;
}
.content ol {
  padding: 0 0 0 15px;
  margin: 0;
  list-style: none;
}
.content ol > li:before {
  content: '\00BB \0020';
}
.content .numeric {
  list-style: decimal;
}
.content .numeric li {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue